import { render, staticRenderFns } from "./GroupPerson.vue?vue&type=template&id=2a559524"
import script from "./GroupPerson.vue?vue&type=script&lang=js"
export * from "./GroupPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports